// Тексты лендинга — английский: образец для всех языков (тип LandingStrings берётся отсюда). Перенесено из компонентов 2026-10-24.
export const en = {
  header: {
    brandSubtitle: 'Potion puzzles',
    contact: 'Contact',
    about: 'About',
    language: 'Language',
  },
  footer: {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    copyright: '{year} {holder}. All rights reserved.',
  },
  home: {
    heroTitle: 'A cozy 3D game about potions and a little magic shop.',
    heroDescription:
      'Hunt for ingredients in the magical clutter, brew potions in a cauldron, and sell them in a shop of your own.',
    features: [
      {
        title: 'Design your own bottle',
        desc: 'Shape, cap, and liquid color — prettier bottles sell for more.',
      },
      {
        title: 'Craft that matters',
        desc: 'Every potion has its own recipe, and many really work in the game.',
      },
      {
        title: 'A story worth following',
        desc: 'Grandma has gone on holiday and left you her shop, and a frog named Moren wants his due.',
      },
      {
        title: 'A shop that’s truly yours',
        desc: 'Only what you brewed yourself is for sale.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Coming soon',
    tags: { search: 'Hidden ingredients', craft: '3D cauldron crafting', shop: 'Cozy magic shop' },
  },
  about: {
    title: 'About Qevryno',
    intro: [
      'Welcome to Qevryno — a cozy potion-brewing game where magic feels handmade.',
      'Grandma has gone on holiday and asked you to look after her mysterious old house: forgotten recipes, magical ingredients, and a cauldron that still remembers how to boil. Downstairs there is a little shop, and the whole village is curious who is minding it now.',
      'Brew potions, care for your fluffy familiar, sell your creations to charming customers, and earn coins to decorate and expand your magical home — at your own pace, with no timers rushing you.',
    ],
    whatTitle: 'What kind of game is it?',
    what: [
      'Qevryno is a relaxing 3D puzzle game that mixes hidden object search, alchemy crafting, and a tiny shop simulator. If you enjoy cozy games, casual puzzle games, merge-free crafting, hidden object games, or games about brewing potions and running a magic shop — this one is made for you.',
      'It is a single-player game that works offline; internet is needed only for purchases and optional rewarded videos. No banners or pop-ups: a short Google AdMob video plays only if you tap for a bonus. Optional purchases: gems and ingredient packs with visible contents. Coming soon to iOS and Android, in English, Russian, Spanish, German, French, Dutch, Italian, Portuguese (Brazil), Polish, Japanese, Korean, Traditional Chinese and Turkish.',
    ],
    doTitle: 'What you will do',
    doList: [
      'Search for hidden ingredients in magical 3D forest glades — each one is a little diorama.',
      'Brew magical recipes in a tactile cauldron: a stabilizer, a main ingredient, herbs of time, and a splash of color.',
      'Design your own potion bottles — shape, cap, and liquid color — prettier bottles sell for more.',
      'Run your own little magic shop: customers, reputation, fairs, and quests.',
      'Follow the story: grandma has gone on holiday and left you her shop, and a frog named Moren keeps demanding his due.',
      'Grind your finds in a mortar, mix them in a bowl and add glitter — every mix has its own texture and color.',
      'Feed and befriend your familiar and decorate your shop.',
    ],
    faqTitle: 'Questions people ask',
    faq: [
      { q: 'Is Qevryno free?', a: 'Yes. The game is free to download and fully playable without paying. Optional purchases: gems and ingredient packs.' },
      { q: 'Does it work offline?', a: 'Yes. The game itself needs no connection — brew potions on a plane or in a blanket fort. Internet is used only for purchases and optional rewarded videos.' },
      { q: 'Are there ads?', a: 'Only optional ones. There are no banners and no pop-ups between screens. In a few places you can choose to watch a short video for a bonus, such as extra mana. Nothing in the game requires watching them. Videos are provided by Google AdMob; see our Privacy Policy.' },
      { q: 'What platforms is it on?', a: 'iOS and Android, in English, Russian, Spanish, German, French, Dutch, Italian, Portuguese (Brazil), Polish, Japanese, Korean, Traditional Chinese and Turkish.' },
      { q: 'Is it scary or stressful?', a: 'Not at all. It is a calm, cozy game — soft music, no fail states that punish you, and a cat in a hat.' },
    ],
  },
  contact: {
    title: 'Contact us',
    subtitle: 'A question about Qevryno, a bug, a purchase or an ad? Write to us by email.',
    write: 'Write an email',
    mailSubject: 'Qevryno support',
    tip: 'Tell us your device and what happened — it helps us help you.',
    info: {
      title: 'Contacts',
      email: 'Email',
      security: 'Security',
      legalName: 'Developer',
      address: 'Address',
    },
    refunds: {
      title: 'Refunds and purchases',
      description: 'All purchases go through the Apple App Store or Google Play. To ask for a refund, contact the store:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/en-us/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637',
      link: 'Request a refund',
      note: 'We do not take payments ourselves and cannot issue refunds. If a purchase did not arrive in the game, open Settings → Restore purchases, or write to us.',
    },
  },
  legal: {
    dataController: 'Data Controller',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: '',
  },
};

export type LandingStrings = typeof en;
